module.exports = __webpack_public_path__ + "static/media/elo.24d5d1c7.svg";